import { SimpleFAQT } from '@components/Organisms/SimpleFAQs/types';
import { useRef } from 'react';
import { renderParagraphs } from '@lib/utils';
import { StyledSimpleFAQ } from '@components/Organisms/SimpleFAQs/styled/StyledSimpleFAQs';

export function SimpleFAQ({
  faq,
  index,
  isActive,
  onClick,
}: {
  faq: SimpleFAQT;
  index: number;
  isActive: boolean;
  onClick: () => void;
}) {
  const contentRef = useRef<HTMLDivElement>(null);

  if (!faq.display) return null;

  return (
    <StyledSimpleFAQ isOpen={isActive}>
      <button onClick={onClick} aria-expanded={isActive} aria-controls={`faq-answer-${index}`}>
        <h3>{faq.question}</h3>
      </button>
      <div
        id={`faq-answer-${index}`}
        ref={contentRef}
        className="answer"
        style={{
          maxHeight: isActive ? `${contentRef.current?.scrollHeight}px` : '0px',
        }}
      >
        {renderParagraphs({ body: faq.answer, hasMarkdown: true })}
      </div>
    </StyledSimpleFAQ>
  );
}
